<template>
  <div>
    <button :class="['hamburger hamburger--collapse', {'is-active': menuOpaque}]" type="button" aria-label="Show Menu" aria-controls="navigation" @click="toggleMenu">
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>
    <!-- nav -->
    <nav :class="['nav', 'menu', {'active': menuActive}, {'opaque': menuOpaque}]" role="navigation">
      <ul class="main-nav" @click="toggleMenu">
        <li class="home"><router-link to="/" :class="[{loaded:homeLoaded}]">Home</router-link></li>
        <li><router-link to="/statement" :class="{loaded:statementLoaded}">Statement</router-link></li>
        <li><router-link to="/partners" :class="{loaded:partnersLoaded}">Partners</router-link></li>
        <li><router-link to="/support" :class="{loaded:supportLoaded}">Support</router-link></li>
        <li><router-link to="/contact" :class="{loaded:contactLoaded}">Contact</router-link></li>
        <li class="home"><a v-show="!showPreviousYears" href="#" :class="[{loaded:contactLoaded}]" @click.stop.prevent="showPreviousYears = true">Previous Years</a></li>
      </ul>
      <ul :class="['secondary-nav', {'active': showPreviousYears}]" @click="toggleMenu">
        <li><router-link to="/2017" :class="{loaded:second2017Loaded}">2017</router-link></li>
        <li><router-link to="/2018" :class="{loaded:second2018Loaded}">2018</router-link></li>
        <li><router-link to="/2019" :class="{loaded:second2019Loaded}">2019</router-link></li>
        <li><router-link to="/2020" :class="{loaded:second2020Loaded}">2020</router-link></li>
      </ul>
      <ul :class="['secondary-nav', {'active': showPreviousYears}]" @click="toggleMenu">
        <li><router-link to="/2021" :class="{loaded:second2021Loaded}">2021</router-link></li>
        <li><router-link to="/2022" :class="[{loaded:second2022Loaded}]">2022</router-link></li>
        <li><router-link to="/2023" :class="[{loaded:second2023Loaded}]">2023</router-link></li>
        <li><router-link to="/2025" :class="[{loaded:second2025Loaded}, { 'router-link-exact-active': currentRoute === 'home' }]">2025</router-link></li>
      </ul>
    </nav>
  </div>
  <!-- /nav -->
</template>

<script>
  export default {
    name: 'MainMenu',
    data : function() {
      return {
        homeLoaded: false,
        statementLoaded: false,
        partnersLoaded: false,
        supportLoaded: false,
        contactLoaded: false,
        second2017Loaded: false,
        second2018Loaded: false,
        second2019Loaded: false,
        second2020Loaded: false,
        second2021Loaded: false,
        second2022Loaded: false,
        second2023Loaded: false,
        second2025Loaded: false,
        menuActive: false,
        menuOpaque: false,
        showPreviousYears: false,
      }
    },
    computed: {
      currentRoute: function() {
        return this.$route.name;
      }
    },
    methods: {
      toggleMenu: function() {
        if (this.menuActive) {
          this.menuOpaque = false;
          setTimeout(() => {
            this.menuActive = false;
            this.showPreviousYears = false;
          }, 300);
        } else {
          this.menuActive = true;
          setTimeout(() => {
            this.menuOpaque = true;
          }, 50);
        }
      }
    },
    beforeMount() {
      if(false) {
        this.homeLoaded= true;
        this.statementLoaded= true;
        this.partnersLoaded= true;
        this.supportLoaded= true;
        this.contactLoaded= true;
        this.second2017Loaded= true;
        this.second2018Loaded= true;
        this.second2019Loaded= true;
        this.second2020Loaded= true;
        this.second2021Loaded= true;
        this.second2022Loaded= true;
        this.second2023Loaded= true;
        this.second2025Loaded= true;
      }
    },
    mounted() {
      const menuItems = ['homeLoaded', 'statementLoaded', 'partnersLoaded', 'supportLoaded', 'contactLoaded', 'second2017Loaded', 'second2018Loaded', 'second2019Loaded', 'second2020Loaded', 'second2021Loaded', 'second2022Loaded', 'second2023Loaded', 'second2025Loaded'];
      setTimeout(() => {
        menuItems.forEach((menuItem, i) => {
          setTimeout(() => {
            this[menuItem] = true;
          }, (100 * i));
        });
      }, 700);
    }
  }
</script>
<style>

</style>


// WEBPACK FOOTER //
// resources/js/components/MainMenu.vue